import React, { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { InputFieldState } from '../types';

/**
 * DelegationDateFormコンポーネント用のPropsです。
 * @interface DelegationDateFormProps
 */
interface DelegationDateFormProps {

  /**
   * 委任日
   * @type {InputFieldState}
   * @memberof DelegationDateFormProps
   */
  delegationDate: InputFieldState;

  /**
   * 提出日
   * @type {InputFieldState}
   * @memberof DelegationDateFormProps
   */
  submissionDate: InputFieldState;

  /**
   * 委任日を設定する関数
   * @memberof DelegationDateFormProps
   */
  onChange: (date: InputFieldState) => void;
  
}

/**
 * 委任日フォームのコンポーネントです。
 * @param {InputFieldState} props.delegationDate - 委任日
 * @param {InputFieldState} props.submissionDate - 提出日
 * @param {function} props.onChange - 委任日が変更されたときに呼ばれるコールバック関数
 * @returns {JSX.Element} - 委任日フォームのJSX要素
 */
const DelegationDateForm: React.FC<DelegationDateFormProps> = ({ delegationDate, submissionDate, onChange }) => {

  // useEffect内の処理とhandleChangeを共通化したいが、委任日の未入力チェックは初回は走らせたくない。
  // 複数回レンダリング走るため、useRefを使ってもNG。
  // propsの見直しが必要。

  useEffect(() => {
    const errorMessage = delegationDate.value === '' ? '' : (new Date(delegationDate.value) > new Date(submissionDate.value) ? '委任日は提出日より前の日付又は同日を入力してください。' : '');
    onChange({
      value: delegationDate.value,
      errorMessage: errorMessage
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onChange, submissionDate.value]);

  /**
   * フォームからフォーカスが外れたときのイベントハンドラーです。
   * 入力された識別番号を整形し、onChange関数を呼び出します。
   * @param {object} event - フォーカスアウトのイベント
   * @returns {void}
   */
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const errorMessage = value === '' ? '委任日が入力されていません。' : (new Date(value) > new Date(submissionDate.value) ? '委任日は提出日より前の日付又は同日を入力してください。' : '');
    onChange({
      value: value,
      errorMessage: errorMessage
    });
  };

  return (
    <Form.Group className="mb-3 row" controlId="formDate">
      <Form.Label className="col-lg-2 col-12 d-flex align-items-center">
        委任日
        <span className="text-small text-danger ms-3">※必須</span>
      </Form.Label>
      <div className="col-lg-10 col-12">
        <Form.Control
          type="date"
          className="form-check-inline"
          value={delegationDate.value}
          onChange={handleChange}
          isInvalid={delegationDate.errorMessage !== ''}
        />
        {delegationDate.errorMessage !== '' ? <div className="text-end text-danger small">{delegationDate.errorMessage}</div> : ''}
      </div>
    </Form.Group>
  );
}

export default DelegationDateForm;